import { createSlice } from "@reduxjs/toolkit";
import { getData } from "../../helper/arrayFormatter";

const storedUser = JSON.parse(getData("user"));
const initialState = {
	userData: storedUser || null,
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		setUser: (state, action) => {
			state.userData = action.payload;
		},
		logoutUser: (state) => {
			state.userData = null;
		},
	},
});

export const { setUser, logoutUser } = authSlice.actions;

export default authSlice.reducer;
